<template>
    <div class="error">
        Неверный логин или пароль
    </div>
</template>

<style scoped>
    .error {
        display: block;
        width: 210px;
        background: rgba(219, 68, 68, 0.8);
        height: 30px;
        border-radius: 7px;
        color: #ffffff;
        box-sizing: border-box;
        font-size: 12px;
        margin-left: 5px;
        margin-top: 10px;
        padding-left: 10px;
    }
</style>